import { Component } from '@angular/core';
import { MenuNavTravelerComponent } from '../menu-nav-traveler/menu-nav-traveler.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-manager-delegation-settings',
    templateUrl: './manager-delegation-settings.component.html',
    styleUrls: ['./manager-delegation-settings.component.scss'],
    imports: [MenuNavTravelerComponent, RouterOutlet]
})
export class ManagerDelegationSettingsComponent {

}
